export const baseUrl = "https://up.stokercloud.dk/uwsapiv2/";
export const forgotPassURL = "dataout2/forgotpass.php";
export const appVersion = "2.35";
export const langFileVersion = "-004";
export const googleMapKey = "AIzaSyCZDRxxU640ytSemg9yEw06DwKmveKpd-Q";

export const countries = [
  {
    name: "Afghanistan",
    value: "AF"
  },
  {
    name: "Åland Islands",
    value: "AX"
  },
  {
    name: "Albania",
    value: "AL"
  },
  {
    name: "Algeria",
    value: "DZ"
  },
  {
    name: "American Samoa",
    value: "AS"
  },
  {
    name: "Andorra",
    value: "AD"
  },
  {
    name: "Angola",
    value: "AO"
  },
  {
    name: "Anguilla",
    value: "AI"
  },
  {
    name: "Antarctica",
    value: "AQ"
  },
  {
    name: "Antigua and Barbuda",
    value: "AG"
  },
  {
    name: "Argentina",
    value: "AR"
  },
  {
    name: "Armenia",
    value: "AM"
  },
  {
    name: "Aruba",
    value: "AW"
  },
  {
    name: "Australia",
    value: "AU"
  },
  {
    name: "Austria",
    value: "AT"
  },
  {
    name: "Azerbaijan",
    value: "AZ"
  },
  {
    name: "Bahamas",
    value: "BS"
  },
  {
    name: "Bahrain",
    value: "BH"
  },
  {
    name: "Bangladesh",
    value: "BD"
  },
  {
    name: "Barbados",
    value: "BB"
  },
  {
    name: "Belarus",
    value: "BY"
  },
  {
    name: "Belgium",
    value: "BE"
  },
  {
    name: "Belize",
    value: "BZ"
  },
  {
    name: "Benin",
    value: "BJ"
  },
  {
    name: "Bermuda",
    value: "BM"
  },
  {
    name: "Bhutan",
    value: "BT"
  },
  {
    name: "Bolivia, Plurinational State of",
    value: "BO"
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    value: "BQ"
  },
  {
    name: "Bosnia and Herzegovina",
    value: "BA"
  },
  {
    name: "Botswana",
    value: "BW"
  },
  {
    name: "Bouvet Island",
    value: "BV"
  },
  {
    name: "Brazil",
    value: "BR"
  },
  {
    name: "British Indian Ocean Territory",
    value: "IO"
  },
  {
    name: "Brunei Darussalam",
    value: "BN"
  },
  {
    name: "Bulgaria",
    value: "BG"
  },
  {
    name: "Burkina Faso",
    value: "BF"
  },
  {
    name: "Burundi",
    value: "BI"
  },
  {
    name: "Cambodia",
    value: "KH"
  },
  {
    name: "Cameroon",
    value: "CM"
  },
  {
    name: "Canada",
    value: "CA"
  },
  {
    name: "Cape Verde",
    value: "CV"
  },
  {
    name: "Cayman Islands",
    value: "KY"
  },
  {
    name: "Central African Republic",
    value: "CF"
  },
  {
    name: "Chad",
    value: "TD"
  },
  {
    name: "Chile",
    value: "CL"
  },
  {
    name: "China",
    value: "CN"
  },
  {
    name: "Christmas Island",
    value: "CX"
  },
  {
    name: "Cocos (Keeling) Islands",
    value: "CC"
  },
  {
    name: "Colombia",
    value: "CO"
  },
  {
    name: "Comoros",
    value: "KM"
  },
  {
    name: "Congo",
    value: "CG"
  },
  {
    name: "Congo, the Democratic Republic of the",
    value: "CD"
  },
  {
    name: "Cook Islands",
    value: "CK"
  },
  {
    name: "Costa Rica",
    value: "CR"
  },
  {
    name: "Côte d'Ivoire",
    value: "CI"
  },
  {
    name: "Croatia",
    value: "HR"
  },
  {
    name: "Cuba",
    value: "CU"
  },
  {
    name: "Curaçao",
    value: "CW"
  },
  {
    name: "Cyprus",
    value: "CY"
  },
  {
    name: "Czech Republic",
    value: "CZ"
  },
  {
    name: "Denmark",
    value: "DK"
  },
  {
    name: "Djibouti",
    value: "DJ"
  },
  {
    name: "Dominica",
    value: "DM"
  },
  {
    name: "Dominican Republic",
    value: "DO"
  },
  {
    name: "Ecuador",
    value: "EC"
  },
  {
    name: "Egypt",
    value: "EG"
  },
  {
    name: "El Salvador",
    value: "SV"
  },
  {
    name: "Equatorial Guinea",
    value: "GQ"
  },
  {
    name: "Eritrea",
    value: "ER"
  },
  {
    name: "Estonia",
    value: "EE"
  },
  {
    name: "Ethiopia",
    value: "ET"
  },
  {
    name: "Falkland Islands (Malvinas)",
    value: "FK"
  },
  {
    name: "Faroe Islands",
    value: "FO"
  },
  {
    name: "Fiji",
    value: "FJ"
  },
  {
    name: "Finland",
    value: "FI"
  },
  {
    name: "France",
    value: "FR"
  },
  {
    name: "French Guiana",
    value: "GF"
  },
  {
    name: "French Polynesia",
    value: "PF"
  },
  {
    name: "French Southern Territories",
    value: "TF"
  },
  {
    name: "Gabon",
    value: "GA"
  },
  {
    name: "Gambia",
    value: "GM"
  },
  {
    name: "Georgia",
    value: "GE"
  },
  {
    name: "Germany",
    value: "DE"
  },
  {
    name: "Ghana",
    value: "GH"
  },
  {
    name: "Gibraltar",
    value: "GI"
  },
  {
    name: "Greece",
    value: "GR"
  },
  {
    name: "Greenland",
    value: "GL"
  },
  {
    name: "Grenada",
    value: "GD"
  },
  {
    name: "Guadeloupe",
    value: "GP"
  },
  {
    name: "Guam",
    value: "GU"
  },
  {
    name: "Guatemala",
    value: "GT"
  },
  {
    name: "Guernsey",
    value: "GG"
  },
  {
    name: "Guinea",
    value: "GN"
  },
  {
    name: "Guinea-Bissau",
    value: "GW"
  },
  {
    name: "Guyana",
    value: "GY"
  },
  {
    name: "Haiti",
    value: "HT"
  },
  {
    name: "Heard Island and McDonald Islands",
    value: "HM"
  },
  {
    name: "Holy See (Vatican City State)",
    value: "VA"
  },
  {
    name: "Honduras",
    value: "HN"
  },
  {
    name: "Hong Kong",
    value: "HK"
  },
  {
    name: "Hungary",
    value: "HU"
  },
  {
    name: "Iceland",
    value: "IS"
  },
  {
    name: "India",
    value: "IN"
  },
  {
    name: "Indonesia",
    value: "ID"
  },
  {
    name: "Iran, Islamic Republic of",
    value: "IR"
  },
  {
    name: "Iraq",
    value: "IQ"
  },
  {
    name: "Ireland",
    value: "IE"
  },
  {
    name: "Isle of Man",
    value: "IM"
  },
  {
    name: "Israel",
    value: "IL"
  },
  {
    name: "Italy",
    value: "IT"
  },
  {
    name: "Jamaica",
    value: "JM"
  },
  {
    name: "Japan",
    value: "JP"
  },
  {
    name: "Jersey",
    value: "JE"
  },
  {
    name: "Jordan",
    value: "JO"
  },
  {
    name: "Kazakhstan",
    value: "KZ"
  },
  {
    name: "Kenya",
    value: "KE"
  },
  {
    name: "Kiribati",
    value: "KI"
  },
  {
    name: "Korea, Democratic People's Republic of",
    value: "KP"
  },
  {
    name: "Korea, Republic of",
    value: "KR"
  },
  {
    name: "Kuwait",
    value: "KW"
  },
  {
    name: "Kyrgyzstan",
    value: "KG"
  },
  {
    name: "Lao People's Democratic Republic",
    value: "LA"
  },
  {
    name: "Latvia",
    value: "LV"
  },
  {
    name: "Lebanon",
    value: "LB"
  },
  {
    name: "Lesotho",
    value: "LS"
  },
  {
    name: "Liberia",
    value: "LR"
  },
  {
    name: "Libya",
    value: "LY"
  },
  {
    name: "Liechtenstein",
    value: "LI"
  },
  {
    name: "Lithuania",
    value: "LT"
  },
  {
    name: "Luxembourg",
    value: "LU"
  },
  {
    name: "Macao",
    value: "MO"
  },
  {
    name: "Macedonia, the former Yugoslav Republic of",
    value: "MK"
  },
  {
    name: "Madagascar",
    value: "MG"
  },
  {
    name: "Malawi",
    value: "MW"
  },
  {
    name: "Malaysia",
    value: "MY"
  },
  {
    name: "Maldives",
    value: "MV"
  },
  {
    name: "Mali",
    value: "ML"
  },
  {
    name: "Malta",
    value: "MT"
  },
  {
    name: "Marshall Islands",
    value: "MH"
  },
  {
    name: "Martinique",
    value: "MQ"
  },
  {
    name: "Mauritania",
    value: "MR"
  },
  {
    name: "Mauritius",
    value: "MU"
  },
  {
    name: "Mayotte",
    value: "YT"
  },
  {
    name: "Mexico",
    value: "MX"
  },
  {
    name: "Micronesia, Federated States of",
    value: "FM"
  },
  {
    name: "Moldova, Republic of",
    value: "MD"
  },
  {
    name: "Monaco",
    value: "MC"
  },
  {
    name: "Mongolia",
    value: "MN"
  },
  {
    name: "Montenegro",
    value: "ME"
  },
  {
    name: "Montserrat",
    value: "MS"
  },
  {
    name: "Morocco",
    value: "MA"
  },
  {
    name: "Mozambique",
    value: "MZ"
  },
  {
    name: "Myanmar",
    value: "MM"
  },
  {
    name: "Namibia",
    value: "NA"
  },
  {
    name: "Nauru",
    value: "NR"
  },
  {
    name: "Nepal",
    value: "NP"
  },
  {
    name: "Netherlands",
    value: "NL"
  },
  {
    name: "New Caledonia",
    value: "NC"
  },
  {
    name: "New Zealand",
    value: "NZ"
  },
  {
    name: "Nicaragua",
    value: "NI"
  },
  {
    name: "Niger",
    value: "NE"
  },
  {
    name: "Nigeria",
    value: "NG"
  },
  {
    name: "Niue",
    value: "NU"
  },
  {
    name: "Norfolk Island",
    value: "NF"
  },
  {
    name: "Northern Mariana Islands",
    value: "MP"
  },
  {
    name: "Norway",
    value: "NO"
  },
  {
    name: "Oman",
    value: "OM"
  },
  {
    name: "Pakistan",
    value: "PK"
  },
  {
    name: "Palau",
    value: "PW"
  },
  {
    name: "Palestinian Territory, Occupied",
    value: "PS"
  },
  {
    name: "Panama",
    value: "PA"
  },
  {
    name: "Papua New Guinea",
    value: "PG"
  },
  {
    name: "Paraguay",
    value: "PY"
  },
  {
    name: "Peru",
    value: "PE"
  },
  {
    name: "Philippines",
    value: "PH"
  },
  {
    name: "Pitcairn",
    value: "PN"
  },
  {
    name: "Poland",
    value: "PL"
  },
  {
    name: "Portugal",
    value: "PT"
  },
  {
    name: "Puerto Rico",
    value: "PR"
  },
  {
    name: "Qatar",
    value: "QA"
  },
  {
    name: "Réunion",
    value: "RE"
  },
  {
    name: "Romania",
    value: "RO"
  },
  {
    name: "Russian Federation",
    value: "RU"
  },
  {
    name: "Rwanda",
    value: "RW"
  },
  {
    name: "Saint Barthélemy",
    value: "BL"
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    value: "SH"
  },
  {
    name: "Saint Kitts and Nevis",
    value: "KN"
  },
  {
    name: "Saint Lucia",
    value: "LC"
  },
  {
    name: "Saint Martin (French part)",
    value: "MF"
  },
  {
    name: "Saint Pierre and Miquelon",
    value: "PM"
  },
  {
    name: "Saint Vincent and the Grenadines",
    value: "VC"
  },
  {
    name: "Samoa",
    value: "WS"
  },
  {
    name: "San Marino",
    value: "SM"
  },
  {
    name: "Sao Tome and Principe",
    value: "ST"
  },
  {
    name: "Saudi Arabia",
    value: "SA"
  },
  {
    name: "Senegal",
    value: "SN"
  },
  {
    name: "Serbia",
    value: "RS"
  },
  {
    name: "Seychelles",
    value: "SC"
  },
  {
    name: "Sierra Leone",
    value: "SL"
  },
  {
    name: "Singapore",
    value: "SG"
  },
  {
    name: "Sint Maarten (Dutch part)",
    value: "SX"
  },
  {
    name: "Slovakia",
    value: "SK"
  },
  {
    name: "Slovenia",
    value: "SI"
  },
  {
    name: "Solomon Islands",
    value: "SB"
  },
  {
    name: "Somalia",
    value: "SO"
  },
  {
    name: "South Africa",
    value: "ZA"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    value: "GS"
  },
  {
    name: "South Sudan",
    value: "SS"
  },
  {
    name: "Spain",
    value: "ES"
  },
  {
    name: "Sri Lanka",
    value: "LK"
  },
  {
    name: "Sudan",
    value: "SD"
  },
  {
    name: "Suriname",
    value: "SR"
  },
  {
    name: "Svalbard and Jan Mayen",
    value: "SJ"
  },
  {
    name: "Swaziland",
    value: "SZ"
  },
  {
    name: "Sweden",
    value: "SE"
  },
  {
    name: "Switzerland",
    value: "CH"
  },
  {
    name: "Syrian Arab Republic",
    value: "SY"
  },
  {
    name: "Taiwan, Province of China",
    value: "TW"
  },
  {
    name: "Tajikistan",
    value: "TJ"
  },
  {
    name: "Tanzania, United Republic of",
    value: "TZ"
  },
  {
    name: "Thailand",
    value: "TH"
  },
  {
    name: "Timor-Leste",
    value: "TL"
  },
  {
    name: "Togo",
    value: "TG"
  },
  {
    name: "Tokelau",
    value: "TK"
  },
  {
    name: "Tonga",
    value: "TO"
  },
  {
    name: "Trinidad and Tobago",
    value: "TT"
  },
  {
    name: "Tunisia",
    value: "TN"
  },
  {
    name: "Turkey",
    value: "TR"
  },
  {
    name: "Turkmenistan",
    value: "TM"
  },
  {
    name: "Turks and Caicos Islands",
    value: "TC"
  },
  {
    name: "Tuvalu",
    value: "TV"
  },
  {
    name: "Uganda",
    value: "UG"
  },
  {
    name: "Ukraine",
    value: "UA"
  },
  {
    name: "United Arab Emirates",
    value: "AE"
  },
  {
    name: "United Kingdom",
    value: "GB"
  },
  {
    name: "United States",
    value: "US"
  },
  {
    name: "United States Minor Outlying Islands",
    value: "UM"
  },
  {
    name: "Uruguay",
    value: "UY"
  },
  {
    name: "Uzbekistan",
    value: "UZ"
  },
  {
    name: "Vanuatu",
    value: "VU"
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    value: "VE"
  },
  {
    name: "Viet Nam",
    value: "VN"
  },
  {
    name: "Virgin Islands, British",
    value: "VG"
  },
  {
    name: "Virgin Islands, U.S.",
    value: "VI"
  },
  {
    name: "Wallis and Futuna",
    value: "WF"
  },
  {
    name: "Western Sahara",
    value: "EH"
  },
  {
    name: "Yemen",
    value: "YE"
  },
  {
    name: "Zambia",
    value: "ZM"
  },
  {
    name: "Zimbabwe",
    value: "ZW"
  }
];

export const languages = [
  {
    name: "English(GB)",
    flag: "gb",
    lang: "uk"
  },
  {
    name: "Dansk",
    flag: "dk",
    lang: "dk"
  }
];

export const sewerTypeValues = [
  {
    name: "lng_select_sewer_type_txt",
    value: "other"
  },
  {
    name: "lng_wavin_315_txt",
    value: "Wavin 315mm"
  },
  {
    name: "lng_wavin_425_txt",
    value: "Wavin 425mm"
  },
  {
    name: "lng_uponor_315_txt",
    value: "Uponor 315mm"
  },
  {
    name: "lng_uponor_425_txt",
    value: "Uponor 425mm"
  },
  {
    name: "lng_kaczmarek_315_txt",
    value: "Kaczmarek 315mm"
  },
  {
    name: "lng_kaczmarek_425_txt",
    value: "Kaczmarek 425mm"
  },
  {
    name: "lng_pipe_315_txt",
    value: "Pipe-Life 315mm"
  },
  {
    name: "lng_pipe_425_txt",
    value: "Pipe-Life 425mm"
  },
  {
    name: "lng_beton_1000_txt",
    value: "Beton 1000mm - P"
  },
  {
    name: "lng_beton_1250_txt",
    value: "Beton 1250mm - P"
  },
  {
    name: "lng_other_txt",
    value: "Other"
  }
];

export const equipmentTypeValues = [
  {
    name: "lng_select_eq_type_txt",
    value: "other"
  },
  {
    name: "lng_equipment_nr_1",
    value: "1"
  },
  {
    name: "lng_equipment_nr_2",
    value: "2"
  },
  {
    name: "lng_equipment_nr_3",
    value: "3"
  },
  {
    name: "lng_equipment_nr_4",
    value: "4"
  },
  {
    name: "lng_equipment_nr_5",
    value: "5"
  },
  {
    name: "lng_equipment_nr_6",
    value: "6"
  },
  {
    name: "lng_equipment_nr_7",
    value: "7"
  },
  {
    name: "lng_equipment_nr_8",
    value: "8"
  },
  {
    name: "lng_equipment_nr_9",
    value: "9"
  },
  {
    name: "lng_equipment_nr_10",
    value: "10"
  },
  {
    name: "lng_equipment_nr_11",
    value: "11"
  },
  {
    name: "lng_equipment_nr_12",
    value: "12"
  },
  {
    name: "lng_equipment_nr_13",
    value: "13"
  },
  {
    name: "lng_equipment_nr_14",
    value: "14"
  },
  {
    name: "lng_equipment_nr_15",
    value: "15"
  },
  {
    name: "lng_equipment_nr_16",
    value: "16"
  },
  {
    name: "lng_equipment_nr_17",
    value: "17"
  },
  {
    name: "lng_equipment_nr_19",
    value: "19"
  },
  {
    name: "lng_equipment_nr_20",
    value: "20"
  },
  {
    name: "lng_equipment_nr_21",
    value: "21"
  },
  {
    name: "lng_equipment_nr_18",
    value: "18"
  }

]

export const userRoles = [
  {
    name: "lng_dealer_txt",
    value: "0"
  },
  {
    name: "lng_end_user_txt",
    value: "1"
  },
  // {
  //   name: "lng_multiuser_txt",
  //   value: "2"
  // },
  {
    name: "lng_admin_txt",
    value: "3"
  },
];

export const countriesWithTwoDigitCode = [
  {
    "name": "Argentina",
    "dial_code": "+54",
    "code": "AR"
  },
  {
    "name": "Australia",
    "dial_code": "+61",
    "code": "AU"
  },
  {
    "name": "Austria",
    "dial_code": "+43",
    "code": "AT"
  },
  {
    "name": "Belgium",
    "dial_code": "+32",
    "code": "BE"
  },
  {
    "name": "Chile",
    "dial_code": "+56",
    "code": "CL"
  },
  {
    "name": "China",
    "dial_code": "+86",
    "code": "CN"
  },
  {
    "name": "Christmas Island",
    "dial_code": "+61",
    "code": "CX"
  },
  {
    "name": "Colombia",
    "dial_code": "+57",
    "code": "CO"
  },
  {
    "name": "Cuba",
    "dial_code": "+53",
    "code": "CU"
  },
  {
    "name": "Denmark",
    "dial_code": "+45",
    "code": "DK"
  },
  {
    "name": "Egypt",
    "dial_code": "+20",
    "code": "EG"
  },
  {
    "name": "France",
    "dial_code": "+33",
    "code": "FR"
  },
  {
    "name": "Germany",
    "dial_code": "+49",
    "code": "DE"
  },
  {
    "name": "Greece",
    "dial_code": "+30",
    "code": "GR"
  },
  {
    "name": "Guernsey",
    "dial_code": "+44",
    "code": "GG"
  },
  {
    "name": "Hungary",
    "dial_code": "+36",
    "code": "HU"
  },
  {
    "name": "India",
    "dial_code": "+91",
    "code": "IN"
  },
  {
    "name": "Indonesia",
    "dial_code": "+62",
    "code": "ID"
  },
  {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "code": "IR"
  },
  {
    "name": "Isle of Man",
    "dial_code": "+44",
    "code": "IM"
  },
  {
    "name": "Italy",
    "dial_code": "+39",
    "code": "IT"
  },
  {
    "name": "Japan",
    "dial_code": "+81",
    "code": "JP"
  },
  {
    "name": "Jersey",
    "dial_code": "+44",
    "code": "JE"
  },
  {
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "code": "KR"
  },
  {
    "name": "Malaysia",
    "dial_code": "+60",
    "code": "MY"
  },
  {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX"
  },
  {
    "name": "Myanmar",
    "dial_code": "+95",
    "code": "MM"
  },
  {
    "name": "Netherlands",
    "dial_code": "+31",
    "code": "NL"
  },
  {
    "name": "New Zealand",
    "dial_code": "+64",
    "code": "NZ"
  },
  {
    "name": "Norway",
    "dial_code": "+47",
    "code": "NO"
  },
  {
    "name": "Pakistan",
    "dial_code": "+92",
    "code": "PK"
  },
  {
    "name": "Peru",
    "dial_code": "+51",
    "code": "PE"
  },
  {
    "name": "Philippines",
    "dial_code": "+63",
    "code": "PH"
  },
  {
    "name": "Poland",
    "dial_code": "+48",
    "code": "PL"
  },
  {
    "name": "Romania",
    "dial_code": "+40",
    "code": "RO"
  },
  {
    "name": "Singapore",
    "dial_code": "+65",
    "code": "SG"
  },
  {
    "name": "South Africa",
    "dial_code": "+27",
    "code": "ZA"
  },
  {
    "name": "Spain",
    "dial_code": "+34",
    "code": "ES"
  },
  {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "code": "LK"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "code": "SJ"
  },
  {
    "name": "Sweden",
    "dial_code": "+46",
    "code": "SE"
  },
  {
    "name": "Switzerland",
    "dial_code": "+41",
    "code": "CH"
  },
  {
    "name": "Thailand",
    "dial_code": "+66",
    "code": "TH"
  },
  {
    "name": "Turkey",
    "dial_code": "+90",
    "code": "TR"
  },
  {
    "name": "United Kingdom",
    "dial_code": "+44",
    "code": "GB"
  },
  {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "dial_code": "+58",
    "code": "VE"
  },
  {
    "name": "Vietnam",
    "dial_code": "+84",
    "code": "VN"
  },
]

/** Service contract / subscription tier codes (API: 0–9). */
export const subscriptionTierValues = [
  { name: "lng_sub_tier_hva_no", value: "0" },
  { name: "lng_sub_tier_hvl_no", value: "1" },
  { name: "lng_sub_tier_hva_basis", value: "2" },
  { name: "lng_sub_tier_hva_bronze", value: "3" },
  { name: "lng_sub_tier_hva_silver", value: "4" },
  { name: "lng_sub_tier_hva_gold", value: "5" },
  { name: "lng_sub_tier_hvl_basis", value: "6" },
  { name: "lng_sub_tier_hvl_bronze", value: "7" },
  { name: "lng_sub_tier_hvl_silver", value: "8" },
  { name: "lng_sub_tier_hvl_gold", value: "9" },
];
